import { render, staticRenderFns } from "./MenuBox.vue?vue&type=template&id=d834c19c&scoped=true&"
import script from "./MenuBox.vue?vue&type=script&lang=js&"
export * from "./MenuBox.vue?vue&type=script&lang=js&"
import style0 from "./MenuBox.vue?vue&type=style&index=0&id=d834c19c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d834c19c",
  null
  
)

export default component.exports